import { useState } from "react";
import { Card, CardBody } from "../ui/Card.jsx";
import HeadingOne from "../ui/HeadingOne.jsx";
import DesktopIcon from "../ui/DesktopIcon.jsx";
import FolderWindow from "../ui/FolderWindow.jsx";
import DesktopModal from "../ui/DesktopModal.jsx";
import ProgressBar from "../ui/ProgressBar.jsx";

const PcProofs = ({ subheading, pcImg, heading, buttons, modals, title, fn }) => {
  const [activeWindow, setActiveWindow] = useState(null);
  const [activeFileModal, setActiveFileModal] = useState(null);
  const [activeFolder, setActiveFolder] = useState(null);
  const [usbProgress, setUsbProgress] = useState(0);

  const handleClick = (btn) => {
    if (btn.action === "folder") {
      setActiveFolder(btn);
    } else {
      setActiveWindow("denied");
    }
  };

  const startUsbUpload = () => {
    setActiveWindow("usbUpload");
    setUsbProgress(0);

    let progress = 0;
    const interval = setInterval(() => {
      progress += 1;
      setUsbProgress(progress);

      if (progress >= 100) {
        clearInterval(interval);
        // Progress bar zůstane otevřený a zobrazí tlačítko
      }
    }, 150); // 100 × 150ms ≈ 15 sekund
  };

  return (
    <div className="component-pc">
      <div className="row">
        <HeadingOne className="col" heading={heading} />
      </div>
      <div className="row justify-center">
        <div className="col 2xl:w-10/12">
          <Card>
            <CardBody>
              <h2 className="text-center text-2xl">{subheading}</h2>

              <div className="flex justify-center items-center relative">
                <div className="relative w-[600px] md:w-[900px] lg:w-[1200px] aspect-[4/3]">

                  {/* ProgressBar */}
                  {activeWindow === "usbUpload" && (
                    <ProgressBar
                      header={activeFolder?.header}
                      progress={usbProgress}
                      done={usbProgress >= 100}
                      button={activeFolder?.files?.find(f => f.action === "upload")?.usbDone?.button}
                      fn={fn}
                      onClose={() => setActiveWindow(null)}
                    />
                  )}

                  <img
                    src={pcImg}
                    alt="Monitor"
                    className="w-full h-full object-contain"
                  />

                  <div className="absolute top-[10%] left-[7%] w-[85%] h-[70%] flex justify-between">
                    <div className="flex flex-col gap-8">
                      {buttons?.slice(0, 4).map((btn, idx) => (
                        <DesktopIcon
                          key={idx}
                          icon={btn.icon}
                          label={btn.title}
                          onClick={() => handleClick(btn)}
                        />
                      ))}
                    </div>

                    <div className="flex flex-col gap-8">
                      {buttons?.slice(4, 8).map((btn, idx) => (
                        <DesktopIcon
                          key={idx}
                          icon={btn.icon}
                          label={btn.title}
                          onClick={() => handleClick(btn)}
                          active={activeFolder?.title === btn.title}
                        />
                      ))}
                    </div>
                  </div>

                  {activeWindow === 'denied' && (
                    <DesktopModal
                      isOpen={true}
                      title={modals.denied.title}
                      message={modals.denied.message}
                      button={modals.denied.button}
                      fn={{ handleAction: () => setActiveWindow(null) }}
                    />
                  )}

                  {activeFolder && (
                    <FolderWindow
                      title={activeFolder.title}
                      files={activeFolder.files ?? []}
                      header={activeFolder.header ?? []}
                      toolbar={activeFolder.toolbar ?? []}
                      sidebar={activeFolder.sidebar ?? []}
                      onClose={() => setActiveFolder(null)}
                      onFileClick={(file) => {
                        if (file.action === "denied") {
                          setActiveFileModal({
                            title: "Přístup zamítnut",
                            message: "Do této složky nemáte oprávnění vstoupit.",
                            button: file.button,
                          });
                        } else if (file.action === "empty") {
                          setActiveFileModal({
                            title: "Složka je prázdná",
                            message: "Tato složka neobsahuje žádné soubory.",
                            button: file.button,
                          });
                        } else if (file.action === "upload") {
                          setActiveFileModal({
                            title: file.label,
                            message: "Nahrát na USB disk?",
                            button: file.button,
                            type: "upload",
                          });
                        }
                      }}
                    />
                  )}

                  {activeFileModal && activeFileModal.type !== "upload" && (
                    <DesktopModal
                      isOpen={true}
                      title={activeFileModal.title}
                      message={activeFileModal.message}
                      button={activeFileModal.button}
                      fn={{ handleAction: () => setActiveFileModal(null) }}
                    />
                  )}

                  {activeFileModal?.type === "upload" && (
                    <DesktopModal
                      isOpen={true}
                      title={activeFileModal.title}
                      message={activeFileModal.message}
                      button={activeFileModal.button}
                      fn={{ handleAction: () => {
                        setActiveFileModal(null);
                        startUsbUpload();
                      }}}
                    />
                  )}

                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PcProofs;
